 const ErrorList={
    "errorDigit":"Ne doit contenir que des chiffres",
    "errorLength":"Longueur maximale du champ dépassée",
    "ModifiedOn": "La date doit etre au format : JJ/MM/AAAA ou AAAA-MM-JJ ou jj/mm/dd",
    "errorBoolean": "Merci de renseigner la valeur O ou N"

}
export default ErrorList